/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import InputBox from '../../../components/InputBox'
import ErrorMessage from '../../../components/ErrorMessage'
import TextArea from '../../../components/TextArea'
import Dropdown from '../../../components/Dropdown'
import TopHeader from '../../../components/TopHeader'
import { useState ,useContext,useEffect} from 'react'
import { useNavigate ,useParams,useLocation} from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import GlobalContext from '../../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { validateEmail } from '../../../CommonMethods/EmailValidator'
import CustomOverLay from '../../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import moment from 'moment'
import Loader from '../../../components/Loader'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen'
import { useAddOrganizationUserMutation } from '../../../features/organizationUserSlice'
import DropdownWithSearchSubDiv from './Components/dropdownSearchSubDiv'
import PhoneNumberValidator from '../../../components/PhoneNumberInput'
import { phoneCodeArray } from '../../../CommonMethods/phoneNumberCountryCodes'
import HelpGuideModal from '../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import { resetProviderSearch } from '../../../redux/providerSearchSlice'

export default function AddOrganizationUser({edit}) {
    const [addOrganizationUser] = useAddOrganizationUserMutation()
    const location=useLocation()
    const [addOrganizationUserDetails,setAddOrganizationUserDetails]=useState({
        "user_name":"",
        "first_name":"",
        "last_name":"",
        "mobile_number":"",
        "main_number":"",
        "sub_division":"",
        "email_addr":"",
        "permission_access":true,
    })
    
    const {id}=useParams()
    const userArr=useSelector(state=>state?.userSelect?.selectedUsers?.checkedArr)
    const dataArr=useSelector(state=>state?.userSelect?.selectedUsers?.data)
    const mapArr =useSelector(state=>state?.userSelect?.selectedUsers?.dataWithName)
    const viewId=useSelector(state=>state?.systemConfigData?.viewToUser)
    const organization_id=useSelector(state=>state?.systemConfigData?.organization_id)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    const [skip,setSkip]=useState(true)
    const {data,isFetching,status}=useAddOrganizationUserMutation(id,{skip:skip})
    const [confirmationState,setConfirmationState]=useState(false)
    const [confirmationStateCancel,setConfirmationStateCancel]=useState(false)
    const { setToastmessage,setToastErrorMessage ,isSideBar,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const [emptyField, setEmptyField] = useState(false)
    const [emailError,setEmailError]=useState({
        "email_error":false,
        "username_error":false
    })
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true});

    
    const [loading,setLoading]=useState(false)
    const navigate=useNavigate()
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')
    const [emptyArea,setEmptyArea]=useState(false);
    const [usernameError,setUsernameError]=useState(false)
    const [loadingStatus,setLoadingStatus]=useState(false)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [submitSelected,setSubmitSelected]=useState(false);


    const dispatch=useDispatch()

    function handleOnChangeUserDetails(id,option){
        setSubmitSelected(false)
        setEmptyField(false)
        setEmailError({
            email_error:false,
            username_error:false
        })
        const fieldToUpdate = {
            user_name:"user_name",
            first_name:"first_name",
            last_name:"last_name",
            mobile_number:"mobile_number",
            main_number:"main_number", 
            sub_division:"sub_division",
            email_addr:'email_addr',
            admin_toggle:"admin_toggle",
            user_toggle:"user_toggle",    
            permission_access:"permission_access",      
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true

        if (id === "mobile_number"||id==="main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setAddOrganizationUserDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if(fieldToUpdate){
            if(fieldToUpdate==="permission_access"){
                setAddOrganizationUserDetails((prev) => ({
                    ...prev,
                    "permission_access": !addOrganizationUserDetails.permission_access,
                }));
            }
            else if(fieldToUpdate==="mobile_number"||fieldToUpdate==="main_number"){
                if(option.length<=20){
                    setAddOrganizationUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if(fieldToUpdate==="first_name"||fieldToUpdate==="last_name"){
                if(option.length<=30){
                    setAddOrganizationUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if(fieldToUpdate==="email_addr"||fieldToUpdate==="user_name"){
                setUsernameError(false)
                if(option.length<=80){
                    setAddOrganizationUserDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.trim(),
                    }));

                }
            }
            else{
                setAddOrganizationUserDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
            
        }

    }

    const handleOnAddOrganizationUser=async()=>{
        setSubmitSelected(true)

        const hasEmptyFields = () => {
            let isFieldsEmpty=false
            if (
                addOrganizationUserDetails.user_name.trim() === "" ||
                addOrganizationUserDetails.first_name.trim() === "" ||
                addOrganizationUserDetails.last_name.trim() === "" ||
                addOrganizationUserDetails.main_number.trim() === ""||
                userArr[0].length===0
                // addOrganizationUserDetails.sub_division.trim() === ""
            ) {
                isFieldsEmpty = true;
            }
            return isFieldsEmpty;

        };
        if (hasEmptyFields()) {

            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");

            return;

        }
        if(validateEmail(addOrganizationUserDetails?.user_name?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "username_error":true
            }))
           
            if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true
                }))
               
            }
            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
        }
        if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  

            setEmailError((prev)=>({
                ...prev,
                "email_error":true
            }))
            setLoading(false);
            return
        }
        if(addOrganizationUserDetails?.email_addr?.trim()!==""&&validateEmail(addOrganizationUserDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true
            }))
            return
        }
        if ((!(isPhoneNumberValid.main_number)&&addOrganizationUserDetails?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&addOrganizationUserDetails?.mobile_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        else{
            setConfirmationState(true)
        }

    }
   
    const handleFinalSubmit=async()=>{
        try {
            setLoading(true)
            let response = null
            let body = {
                "user_name":addOrganizationUserDetails.user_name.trim().replace(/\s/g, ''),
                "first_name": addOrganizationUserDetails.first_name.trim(),
                "last_name": addOrganizationUserDetails.last_name.trim(),
                // "email_address": addOrganizationUserDetails.user_name.trim().replace(/\s/g, ''),
                "mobile_number": addOrganizationUserDetails.mobile_number,
                "organization_id":organization_id,
                "main_number": addOrganizationUserDetails.main_number,
                "main_country_code": "+"+(countryCodeVal!==""?countryCodeVal.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                "mobile_country_code": "+"+(countryCodeVal2!==""?countryCodeVal2.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                "permission_access": addOrganizationUserDetails.permission_access === true ? "admin" : "user",
                "sub_divisions": mapArr.filter(obj=>userArr[0].includes(obj.id)).map((item)=>({"id":item.id}))
            }
            
            const addRes=await addOrganizationUser(body)
         
            if(addRes?.error?.data?.message){
                setConfirmationState(false)
                setToastErrorMessage(addRes?.error?.data?.message)
                setLoading(false)
                if(addRes?.error?.data?.message==="Username already exists. Please try another"){
                    setUsernameError(true)
                }
            }
            else{
                navigate(`/manage-organizations/manage-organization-users/${addRes?.data?.object_id}`,{state:{"user_id":addRes?.data?.user_id}})
                setToastmessage(addRes?.data?.message);
                setLoading(false)
            }
               
            
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }
    }
    useEffect(()=>{
        if(edit){
            setSkip(false) 
        }     
    },[edit])
    useEffect(()=>{
        if(data!==undefined){
            setAddOrganizationUserDetails((prev)=>({
                ...prev,
                "user_name":data?.user_name,
                "first_name":data?.first_name,
                "last_name":data?.last_name,
                "email_addr":data?.email_address,
                "mobile_number":data?.mobile_number,
                "main_number":data?.main_number,
            }))
            setSkip(true)
        }
        if(data&& edit){
            setCountryCodeVal(data?.country_code1.split('+')[1])
            setCountryCodeVal2(data?.country_code2.split('+')[1])
        }
    },[data])
 
    
    const handleConformationClick = () => {
        setEmptyArea(false)
        setConfirmationState(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    const handleCancel = () => {
        setConfirmationStateCancel(false);
        // Clear form values
        setAddOrganizationUserDetails({
            "user_name": "",
            "first_name": "",
            "last_name": "",
            "mobile_number": "",
            "main_number": "",
            "sub_division": "",
            "email_addr": "",
            "permission_access": true,
        });
        navigate('/manage-organizations/manage-organization-users')
    };
    
    const handleCancelBottom = () => {
        const stateToPass = Array.isArray(location.state) ? '' : location.state;

        const values = Object.values(addOrganizationUserDetails);
        const isAnyValueFilled = values?.some((value) => typeof value!== "boolean" &&value?.trim() !== ""); // Check if any value is filled
        
        if (!isAnyValueFilled) {
            navigate('/manage-organizations/manage-organization-users',{state:stateToPass})
        } else {
            setConfirmationStateCancel(true);
            // navigate('/manage-organizations/manage-organization-users/add-organization-user');
        }
    };

    useEffect(() => {
        if (edit) {
            setQueryParamsadmin('type=admin-edit-org-user');
        } else {
            setQueryParamsadmin('type=admin-add-org-user');
        }
    }, [edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const handleGoBackToOrgList = (e) => {
        e.preventDefault();
        dispatch(resetProviderSearch());
        setIsAdvancedSearchOpen(false);
        navigate("/manage-organizations", { state: Array.isArray(location.state) ? '' : location.state });
    };
    
    const date=dateformat?.includes('AM/PM')?moment(data?.created_at+'Z')?.utcOffset('+05:30')?.format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(data?.created_at).format(dateformat)
    return (
        <>
            
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full'>
                <TopHeader title={"Manage Organization User"}/>
                {((edit&&isFetching&&status!=="fulfilled")||loadingStatus)?<CustomOverLay Active text="Add Organization User..." classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>
                    <div className='bg-white rounded-lg pb-[12px] pt-3.5 pl-6 pr-[10px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='pr-6'>
                                    <div className='flex items-center mb-5'>
                                        <h1 className="text-sm font-normal text-[#52555D] cursor-pointer"
                                            onClick={handleGoBackToOrgList}
                                        >List of Organizations</h1>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <Link to={`/manage-organizations/${viewId}`}>
                                            <h1 className="text-sm font-normal text-[#52555D]">View Organization</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <Link to="/manage-organizations/manage-organization-users" state={Array.isArray(location.state)?'':location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Organization Users</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`${edit?'Edit ':'Add '}Organization User`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    <div onClick={handleCancelBottom} state={Array.isArray(location.state)?'':location.state} className='flex cursor-pointer items-center'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </div>
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        {`${edit?'Edit ':'Add '}Organization User`}
                                    </h1>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className={`pr-5 h-customh16 overflow-auto overflow-x-hidden scrollbar_purple bg-white`}>
                                    <div className="border border-[#C5C9DA] rounded-sm px-6 2xl:px-[57px] py-4 mb-4">
                                        
                                        <div className='flex flex-wrap -mx-3'>
                                            {!edit&&<div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Username*"} 
                                                        placeholder={"Enter username"}
                                                        id={"user_name"}
                                                        htmlFor={"Admin_Username"}
                                                        value={addOrganizationUserDetails.user_name}
                                                        emailError={emailError.username_error}
                                                        usernameError={usernameError}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.user_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                    {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '}  message={"Invalid user name"}/>}
                                                </div>
                                            </div>}
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"First Name*"} 
                                                        placeholder={"Enter first name"}
                                                        id={"first_name"}
                                                        htmlFor={"Admin_First_Name"}
                                                        value={addOrganizationUserDetails.first_name}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.first_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Last Name*"} 
                                                        placeholder={"Enter last name"}
                                                        id={"last_name"}
                                                        htmlFor={"Admin_Last_Name"}
                                                        value={addOrganizationUserDetails.last_name}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.last_name?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <PhoneNumberValidator
                                                        label={"Mobile Number"}
                                                        placeholder={"Enter Mobile Number"}
                                                        id={"mobile_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addOrganizationUserDetails.mobile_number}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal2}
                                                        isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        setCountryCodeVal={setCountryCodeVal2}
                                                        submitSelected={submitSelected}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <PhoneNumberValidator
                                                        label={"Main Number*"} 
                                                        placeholder={"Enter Main Number"}
                                                        id={"main_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addOrganizationUserDetails.main_number}
                                                        emptyField={emptyField&&addOrganizationUserDetails?.main_number?.trim()===""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal}
                                                        setCountryCodeVal={setCountryCodeVal}
                                                        isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        submitSelected={submitSelected}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <DropdownWithSearchSubDiv
                                                        label={"Sub Divisions*"}
                                                        id={`sub_divisions`}
                                                        placeholder={(dataArr.length===0||userArr[0]?.length<1)?'Select sub division name':`${userArr[0]?.length} Selected`}
                                                        disabled={false}
                                                        index={0}
                                                        // value={newOrgFields[index].organizations}
                                                        emptyField={emptyField&&userArr[0].length===0}
                                                        // DropdownSearch={useGetSubDivQuery()}

                                                    />
                                                </div>
                                            </div>
                                            <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Email Address*"} 
                                                        placeholder={"Enter email address"}
                                                        id={"email_addr"}
                                                        htmlFor={"email_addr"}
                                                        value={addOrganizationUserDetails.user_name}
                                                        emptyField={false}
                                                        disabled={true}
                                                        emailError={emailError.email_error}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                    {emailError.email_error && <ErrorMessage error  message={"Invalid email address"}/>}
                                                </div>
                                            </div>
                                            {/* <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Email Address*"} 
                                                        placeholder={"Enter email address"}
                                                        id={"email_addr"}
                                                        htmlFor={"email_addr"}
                                                        value={addOrganizationUserDetails.email_addr}
                                                        emptyField={false}
                                                        emailError={emailError.email_error}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                    {emailError.email_error && <ErrorMessage error  message={"Invalid email address"}/>}
                                                </div>
                                            </div> */}
                                            <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <p className='text-sm font-semibold text-[#000000] mb-1.5'>Permission Access</p>
                                                    <div className='flex items-center'>
                                                        <div className="p-2">
                                                            <div className="relative custom-radioBlue flex items-center">
                                                                <input id="admin_true" type="radio" name="default-radio1" checked={addOrganizationUserDetails?.permission_access} onChange={()=>handleOnChangeUserDetails("permission_access",false)}/>
                                                                <label htmlFor="admin_true" className={`text-base font-normal ${addOrganizationUserDetails?.permission_access ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                                    Admin
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="p-2">
                                                            <div className="relative custom-radioBlue flex items-center" >
                                                                <input id="user_true"  type="radio" name="default-radio1" checked={!addOrganizationUserDetails?.permission_access} onChange={()=>handleOnChangeUserDetails("permission_access",true)}/>
                                                                <label htmlFor="user_true" className={`text-base font-normal ${!addOrganizationUserDetails?.permission_access ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                                    User 
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                <div className='flex justify-end pr-5'>
                                    <button
                                        type="button"
                                        id="cancel"
                                        onClick={() => handleCancelBottom()}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
        border border-[#972E4C] `}
                                    >
                                        Cancel
                                    </button>
                                    <button type='button'
                                        id="update"
                                        onClick={handleOnAddOrganizationUser}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px] ml-4
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {confirmationState && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={""}
                                handleOnCLickActivate={handleFinalSubmit}
                                handleClose={handleConformationClick}
                                tittle= {"Add Organization User"}
                                message = {`Are you sure you want to add this organization user?`}
                                textMessage = {true===false?false:true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    /> 
                }
                {confirmationStateCancel && 
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                textMessage = {true===false?false:true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                                CancelButton={'No'}
                            />
                        }
                    /> 
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )}
